// extracted by mini-css-extract-plugin
export default {"mainFunctionalities":"MainFunctionalities_mainFunctionalities__4O9od"};